module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_oval_chestnut.c8c546a7.png";